import "./main.css";


export function Main() {
  const goToLink = () => {
    window.location.href = "https://t.me/MilaDuPhotoPro";
  };
  return (
    <div id="home" className="container- header">
   
      <div className="row">
        <div className="col-1">
          <div className="vertical-line">
        
          </div>
        </div>

        <div className=" mainText col-11 d-flex flex-column align-items-start text-start">
          <h1 className="text1Header">Стильные фотографии</h1>
          <h1 className="text1Header">от професcионального 
            <br className="d-block d-md-none "></br> фотографа</h1>
          <h1 className="text1Header ">в Москве</h1>
          <h3 className="text2Header ">
            - 5 фото на следующий день после съемки <br className="d-block d-md-none "></br>(отбирает фотограф)
          </h3>
          <h3 className="text2Header ">
            - 10-40 фото в течении 5-10 дней <br className="d-block d-md-none "></br>(в зависимости от выбранного
            пакета)
          </h3>
          <h3 className="text2Header">- помощь в подборе образа</h3>
          <h3 className="text2Header">- подбор локации</h3>
          <h3 className="text2Header">- помощь в позинге </h3>
          <br></br>
          <h3 className="text2Header">Запишитесь на бесплатную консультацию</h3>
          <br></br>

          <button class="btn-my-custom-color" type="button" onClick={goToLink}>
            Записаться на консультацию
          </button>
        </div>
      </div>
    </div>
  );
}
